import axios from 'axios';
import { API_BASE } from '../config/info';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

const AUTH_KEY = 'chans_nest_website_auth';

export const getStoredAuth = () => {
  try {
    const s = localStorage.getItem(AUTH_KEY);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
};

export const setStoredAuth = (token, user) => {
  if (token && user) localStorage.setItem(AUTH_KEY, JSON.stringify({ token, user }));
  else localStorage.removeItem(AUTH_KEY);
};

/** Set by AuthProvider so 401 responses clear React user state */
let authFailureHandler = null;
export function setAuthFailureHandler(fn) {
  authFailureHandler = fn;
}

api.interceptors.request.use((config) => {
  const auth = getStoredAuth();
  if (auth?.token) config.headers.Authorization = `Bearer ${auth.token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      const h = error.config?.headers || {};
      if (h.Authorization || h.authorization) {
        setStoredAuth(null, null);
        authFailureHandler?.();
      }
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  sendLoginOtp: (email, password) => api.post('/api/auth/send-login-otp', { email, password }),
  login: (email, password, otp) => api.post('/api/auth/login', { email, password, otp }),
  signupCustomer: (data) => api.post('/api/auth/signup-customer', data),
  verifySignupOtp: (email, otp) => api.post('/api/auth/verify-signup-otp', { email, otp }),
  forgotPassword: (email) => api.post('/api/auth/forgot-password', { email }),
  resetPassword: (email, otp, newPassword) => api.post('/api/auth/reset-password', { email, otp, newPassword }),
  getProfile: () => api.get('/api/users/profile'),
  updateProfile: (data) => api.put('/api/users/profile', data),
};

export const getMyOrders = () => api.get('/api/orders/my');
export const getOrder = (orderId) => api.get(`/api/orders/${orderId}`);
export const updateOrder = (orderId, data) => api.put(`/api/orders/${orderId}`, data);
export const patchOrder = (orderId, data) => api.patch(`/api/orders/${orderId}`, data);
export const createReserve = (data) => api.post('/api/orders/reserve', data);

export const getRooms = () => api.get('/api/rooms/public');
/** Optional startDate/endDate (YYYY-MM-DD). If omitted, server uses today to next month. Returns { rooms, orders, startDate, endDate }. */
export const getRoomsWithAvailability = (startDate, endDate) =>
  api.get('/api/rooms/public/availability', startDate && endDate ? { params: { startDate, endDate } } : {});
export const checkAvailability = (roomId, checkIn, checkOut) =>
  api.get('/api/rooms/availability', { params: { roomId, checkIn, checkOut } });
export const createBooking = (data) => api.post('/api/bookings', data);

/** Menu: fetch all products (no auth required for GET) */
export const getProducts = () => api.get('/api/products');
export const getCategories = () => api.get('/api/categories');

export default api;
